import React from 'react';
import cbtManagement from '../../../../../../apis/cbtManagement';
import { CONFIG } from '../../../../../../config';
import PencapaianIndikatorSearch from '../../../../../../entity/PencapaianIndikatorSearch';
import Loader from '../../../../../Loader';
import __ from 'lodash';
import ChartComp from './ChartComp';
//up
class PencapaianIndikator extends React.Component{
    
    state = {
        indikator: [],
        isLoading: false
    }
    componentDidMount(){
        this.fetchPencapaianIndikator();
        console.log("CHART REF")
        console.log(this.chartRef)
        
        
    }

    fetchPencapaianIndikator = async () =>{
        this.setState({
            isLoading: true
        })
        const response = await cbtManagement.post(CONFIG.CBT_MANAGEMENT_PENCAPAIAN_INDIKATOR,
            {...PencapaianIndikatorSearch,
                ["idSekolah"]: this.props.idSekolah,
                ["idProfil"]: this.props.idProfil,
                ["idSubProfil"]: this.props.idSubProfil,
                ["idSiswa"]: this.props.idSiswa,
                ["idKelasParalel"]: this.props.idKelasParalel,
                ["kodeTahunAjaran"]: this.props.kodeTahunAjaran
            }).catch(function(error){

            })
        if(response){
            if(response.data !== null){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        indikator: response.data.data
                    })
                }
            }
        }
        this.setState({
            isLoading: false
        })
    }

    renderTabelAnalisis = () => {
        if(!__.isEmpty(this.state.indikator)){
            return this.state.indikator.map((indi) => {
                const persentase = parseFloat( ( indi.jumlahBenar / (indi.jumlahSoal * indi.jumlahSiswa) ) * 100).toFixed(2);
                return (
                    <tr>
                        <td>{indi.namaIndikator}</td>
                        <td>{indi.jumlahSoal}</td>
                        <td>{indi.jumlahSiswa}</td>
                        <td>{indi.jumlahBenar}</td>
                        <td>{persentase}%</td>
                    </tr>
                )
            })
        }
    }

    renderAnalisis = () =>{
        if(this.state.isLoading){
            return (
                <div>
                    <Loader />
                </div>
            )
        }else{
            const navTabId = "tab" + this.props.idSubProfil;
            const tabelTabId = "tableTab" + this.props.idSubProfil;
            const grafikTabId = "grafikTab" + this.props.idSubProfil;
            const hrefTable = "#table" + this.props.idSubProfil;
            const hrefGrafik = "#grafik" + this.props.idSubProfil;
            const tableId = "table" + this.props.idSubProfil;
            const grafikId = "grafik" + this.props.idSubProfil;
            const tabContentId = "tabContent" + this.props.idSubProfil;

            
            return(
                <div>
                    <ul className="nav nav-tabs" id={navTabId} role="tablist">
                        <li className="nav-item">
                            <a className="nav-link active" id={tabelTabId} data-toggle="tab" href={hrefTable} role="tab" aria-controls={tableId} aria-selected="true">Tabel</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" id={grafikTabId} data-toggle="tab" href={hrefGrafik} role="tab" aria-controls={grafikId} aria-selected="false">Grafik</a>
                        </li>
                    </ul>
                    <div className="tab-content" id={tabContentId}>
                    <div className="tab-pane fade show active" id={tableId} role="tabpanel" aria-labelledby="home-tab">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Indikator</th>
                                    <th scope="col">Jumlah Soal</th>
                                    <th scope="col">Jumlah Siswa</th>
                                    <th scope="col">Jumlah Benar</th>
                                    <th scope="col">Persentase</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderTabelAnalisis()}
                            </tbody>
                        </table>
                    </div>
                    <div className="tab-pane fade" id={grafikId} role="tabpanel" aria-labelledby="profile-tab">
                        <ChartComp indikator={this.state.indikator}/>
                    </div>
                    </div>
                </div>
            )
        }
    }

    render(){
        return(
            <div>
                {this.renderAnalisis()}
                
            </div>
        )
    }
}

export default PencapaianIndikator;